import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: 'timer',
      title: 'Timed Quizzes',
      description: 'Practice under exam-like conditions with timed quizzes. Set your own pace or challenge yourself with time limits.',
      color: '#4F46E5'
    },
    {
      icon: 'analytics',
      title: 'Performance Analytics',
      description: 'Get detailed insights into your strengths and areas for improvement with comprehensive performance analytics.',
      color: '#059669'
    },
    {
      icon: 'book',
      title: 'Subject Coverage',
      description: 'Access a wide range of subjects including Geography, Programming, Mathematics, and more. Content is regularly updated.',
      color: '#D97706'
    },
    {
      icon: 'groups',
      title: 'Study Groups',
      description: 'Create or join study groups to practice together and share knowledge with other students.',
      color: '#7C3AED'
    }
  ];

  return (
    <section className="features">
      <div className="features-header">
        <h2>Advanced Learning Features</h2>
        <p>Everything you need to enhance your learning experience</p>
      </div>

      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon" style={{ backgroundColor: `${feature.color}15` }}>
              <span className="material-icons" style={{ color: feature.color }}>
                {feature.icon}
              </span>
            </div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features; 